import React from 'react';
import {observer, useLocalStore} from "mobx-react-lite";
import {AppBar, Toolbar, IconButton, Button, Menu, MenuItem, TextField} from "@material-ui/core";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import AppsIcon from '@material-ui/icons/Apps';
import Logo from "../../../core/Logo";
import Language from '../../../core/Language';
import { navbarStyles } from '../Styles/NavbarStyles';
import { useStores } from '../../../_stores';



type NavbarProps = {
    openSidebar: Function;
    getText?: Function;
}

const Navbar = observer((props: NavbarProps) => {
    const {openSidebar} = props;
    const classes = navbarStyles();
    // const { userStore } = useStores();
    



    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClose = () => setAnchorEl(null);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar variant="dense" className={classes.mainToolbar}>
                    <div className={classes.mainLogo}>
                        <Logo classes={classes.logo} viewBox={{X: 0, Y: 0, height: 280, width: 400}}/>
                    </div>
                    <div className={classes.root}/>
                    <div className={classes.sectionDesktop}>
                        <Language/>
                        {/* <Button 
                            className={classes.userButton}
                            size="medium"
                            endIcon={<ArrowDropDownIcon fontSize="inherit" />}
                            onClick={handleClick}
                        >
                            {userStore.email}
                        </Button> */}
                        
                    </div>
                </Toolbar>
            </AppBar>
            <AppBar position="static">
                <Toolbar style={{backgroundColor: 'white'}}>
                    <IconButton
                        edge="start"
                        className={classes.menuButton}
                        color="inherit"
                        aria-label="menu"
                        onClick={() => openSidebar()}
                    >
                        <AppsIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            
        </div>
    );
});

export default Navbar;
